<template>
  <div class="layout-info slide-in-top">
    <div class="account">
      <div class="iconBoxG">
        <svg-icon icon-name="system" class="infoIcon"></svg-icon>
      </div>
<!--      <span class="pointer fluorescent_green" @click="onAdmin">后台管理</span>-->
    </div>

    <div class="account">
      <div class="iconBoxG">
        <svg-icon icon-name="account"></svg-icon>
      </div>
      <span>{{ username }}</span>

      <div
        class="pointer fluorescent_green"
        style="margin-left: 15px"
        @click="onLogout"
      >
        退出
      </div>
    </div>
  </div>
</template>

<script>
import {
  setCookieWithResidueTime,
  getCookie,
  delCookie,
} from "@/utils/setCookie";
export default {
  name: "",
  props: {
    username: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      admin: process.env.VUE_APP_ADMIN,
    };
  },
  computed: {},
  created() {},
  methods: {
    onLogout() {
      this.$confirm("此操作将退出系统, 是否继续?", "确认操作", {
        type: "info",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        customClass: "logout-confirm",
      })
        .then(() => {
          delCookie("kefuToken");
          let baseUrl = localStorage.getItem("oldUrl");
          window.location.href = baseUrl + "login.html";
        })
        .catch(() => {});
    },
    onAdmin() {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");
      window.open(`${this.admin}?token=${token}&refreshToken=${refreshToken}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-info {
  position: absolute;
  top: 6%;
  right: 75px;
  display: flex;
  z-index: 4;

  .iconBoxG {
    width: 24px;
    height: 24px;
    display: flex;
    margin-right: 3px;
    justify-content: center;
    align-items: center;
    background-color: rgba(9, 88, 47, 0.5);
    box-shadow: 0 0 20px 3px rgba(9, 88, 47, 1);

    .infoIcon {
      font-size: 16px;
    }
  }

  .account {
    font-family: HarmonyOS_Sans_SC_Regular, serif;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    color: #fff;
    padding: 0 10px;
    margin-left: 10px;
    font-size: 16px;
  }

  .remind-dialog {
    position: absolute;
    top: 37px;
    width: 600px;
    height: 320px;
    padding: 10px;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    box-shadow: 0px 0px 10px 2px rgba(146, 159, 168, 0.4) inset;
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.9);
  }

  .fluorescent_green {
    font-family: HarmonyOS_Sans_SC_Regular, serif;
  }
}
</style>
